module.exports = __webpack_public_path__ + "img/fi-rr-chess.92547799.svg";